/* ═══════════════════════════════════════════════════════════
   Editorial theme — small enhancers:
   1. Wraps a discount code (e.g. "15OFF") in the announcement
      bar with a terracotta pill span.
   2. Tags the "Sale" nav item with .et-sale so CSS can colour
      it terracotta even if its URL is a custom collection.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ── 1. Announcement-bar discount-code pill ───────────────
  // Match common code patterns: 4-10 chars, ALL CAPS, contains
  // at least one digit OR explicitly "OFF"/"SALE"/"SAVE". We
  // intentionally only wrap the *first* match per node so we
  // don't double-wrap.
  function decorateAnnouncementCodes(root) {
    var nodes = root.querySelectorAll(
      '.utility-bar .announcement-bar__message span, ' +
      '.utility-bar .announcement-bar__message'
    );
    nodes.forEach(function (n) {
      if (n.dataset.etCodeDone === '1') return;
      // Only operate on text-only nodes to avoid breaking any
      // existing inline markup.
      if (n.children && n.children.length > 0) {
        // The message wraps a span; if we see only the inner span as
        // a child, we'll let the inner-span pass handle it.
        n.dataset.etCodeDone = '1';
        return;
      }
      var html = n.innerHTML;
      // Pattern: an ALL-CAPS token (4–10 chars) made of letters/digits,
      // containing at least one digit OR matching well-known words.
      var pattern = /\b([A-Z0-9]{4,10})\b/g;
      var replaced = false;
      var newHtml = html.replace(pattern, function (match) {
        if (replaced) return match;
        // Skip very common all-caps words that aren't codes.
        if (/^(WITH|FREE|ONLY|FROM|SHOP|NEW|BEST|SALE|GIFT|ENJOY|YOUR|CODE|OFFER|TODAY|ORDER|ITEMS)$/.test(match)) return match;
        if (!/\d/.test(match) && !/(OFF|SAVE|SALE|DEAL)/.test(match)) return match;
        replaced = true;
        return '<span class="et-code-pill">' + match + '</span>';
      });
      if (replaced) n.innerHTML = newHtml;
      n.dataset.etCodeDone = '1';
    });
  }

  // ── 2. Tag the Sale link in the inline nav ───────────────
  function tagSaleLink(root) {
    var items = root.querySelectorAll('.header__inline-menu .header__menu-item');
    items.forEach(function (a) {
      var label = (a.textContent || '').trim().toLowerCase();
      if (label === 'sale' || label === 'indirim' || label === 'outlet') {
        a.classList.add('et-sale');
      }
    });
  }

  // ── 3. Wrap last word of homepage section titles in
  //       italic terracotta accent. Conservative scope —
  //       only the explicit selectors below.
  var TITLE_SELECTORS = [
    '.collection__title .title.inline-richtext',
    '.featured-collection .title.inline-richtext',
    '.title-wrapper-with-link .title.inline-richtext',
    '.image-with-text__heading',
    '.seo-article__title',
    '.main-page-title.page-title',
    '.title-wrapper-cart-items .title--primary',
    'h1.title--primary'
  ];
  function decorateTitles(root) {
    TITLE_SELECTORS.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (n) {
        if (n.dataset.etTitled === '1') return;
        // Skip if merchant has already styled with inline HTML.
        if (n.children && n.children.length > 0) {
          n.dataset.etTitled = '1';
          return;
        }
        var raw = (n.textContent || '').trim().replace(/\.$/, '');
        if (!raw) return;
        var words = raw.split(/\s+/);
        if (words.length < 2) {
          n.dataset.etTitled = '1';
          return;
        }
        var bold = words.slice(0, -1).join(' ');
        var italic = words[words.length - 1];
        n.innerHTML = '';
        n.appendChild(document.createTextNode(bold + ' '));
        var span = document.createElement('span');
        span.className = 'et-italic';
        span.textContent = italic + '.';
        n.appendChild(span);
        n.dataset.etTitled = '1';
      });
    });
  }

  // ── 4. Move slider counter + arrows + View All next to the title (desktop only)
  //    On mobile (<750px) buttons stay in their original location below the slider.
  var DESKTOP_MQ = '(min-width: 750px)';
  function inlineViewAll(root) {
    root.querySelectorAll('.collection').forEach(function (collection) {
      var titleWrap = collection.querySelector('.collection__title.title-wrapper, .title-wrapper-with-link');
      var sliderBtns = collection.querySelector('.slider-buttons');
      var viewAllWrap = collection.querySelector('.collection__view-all');
      if (!sliderBtns) return;

      // First-time setup: stash the original parent + remember View All anchor
      if (collection.dataset.etInlineDone !== '1') {
        if (!sliderBtns.dataset.etOriginalParent) {
          var parent = sliderBtns.parentElement;
          parent.dataset.etOriginalSliderBtns = '1';
        }
        if (viewAllWrap) {
          var anchor = viewAllWrap.querySelector('a');
          if (anchor) {
            anchor.classList.add('et-view-all-inline');
            sliderBtns.appendChild(anchor);
            sliderBtns.classList.add('has-inline-view-all');
            viewAllWrap.classList.add('collection__view-all--inline');
          }
        }
        collection.dataset.etInlineDone = '1';
      }

      // Place buttons based on viewport
      var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
      if (isDesktop && titleWrap) {
        if (sliderBtns.parentElement !== titleWrap) {
          sliderBtns.classList.add('et-buttons-in-title');
          titleWrap.appendChild(sliderBtns);
          titleWrap.classList.add('et-has-inline-buttons');
        }
      } else {
        // Move back below the slider (after the <ul>)
        var sliderComponent = collection.querySelector('slider-component');
        if (sliderComponent && sliderBtns.parentElement !== sliderComponent) {
          sliderComponent.appendChild(sliderBtns);
          sliderBtns.classList.remove('et-buttons-in-title');
          if (titleWrap) titleWrap.classList.remove('et-has-inline-buttons');
        }
      }
    });
  }

  // Re-place slider buttons on viewport changes
  if (window.matchMedia) {
    var mql = window.matchMedia(DESKTOP_MQ);
    var onMQChange = function () { inlineViewAll(document); };
    if (mql.addEventListener) mql.addEventListener('change', onMQChange);
    else if (mql.addListener) mql.addListener(onMQChange);
  }

  function run() {
    decorateAnnouncementCodes(document);
    tagSaleLink(document);
    decorateTitles(document);
    inlineViewAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
